import { render } from "./TeacherCategory.vue?vue&type=template&id=8fb98788"
import script from "./TeacherCategory.vue?vue&type=script&lang=js"
export * from "./TeacherCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__